import {
  Component,
  NgZone
} from "@angular/core";
import {
  ModalController,
  NavController,
  NavParams,
  ToastController
} from "ionic-angular";
import {
  APIServiceProvider
} from "../../../common/services/api.service";
import {
  Toast
} from "@ionic-native/toast";
import {
  CustomerModalPage
} from "../../../modals/customer/customer.modal";
import {
  OrderdetailsModalPage
} from "../../../modals/orderdetails/orderdetails.modal";
import {
  NotifyService
} from "../../../services/notify.service";

import {
  HelperServiceProvider
} from "../../../common/services/helper.service";

@Component({
  selector: "page-ordercancelled",
  templateUrl: "ordercancelled.html"
})
export class OrdercancelledPage {
  public ordersData: any = [];
  public ordersApiResponse: any;
  private apiUrl: any = "orders/all";
  public postParams: any = {
    order_status: -1,
    dispatched_to: localStorage.getItem("user-id")
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public apiService: APIServiceProvider,
    public zone: NgZone,
    public toast: Toast,
    public helperService: HelperServiceProvider,
    public toastCtrl: ToastController,
    public modalController: ModalController,
    private notifyService: NotifyService
  ) {
    this.notifyService.orderCancelled.subscribe(() => {
      this.getOrders();
    });
  }

  ionViewDidLoad() {
    this.getOrders();
  }

  getOrders(refresh ? ) {
    this.apiService.post(this.apiUrl, this.postParams).subscribe(data => {
      this.ordersData = data["data"]["data"];
      this.ordersApiResponse = data["data"];
      if (refresh) {
        refresh.complete();
      }
    });
  }

  doInfiniteScroll(infiniteScroll) {
    if (!this.ordersApiResponse.next_page_url ||
      this.ordersApiResponse.next_page_url === "" ||
      this.ordersApiResponse.next_page_url === null ||
      this.ordersApiResponse.next_page_url === "null"
    ) {
      infiniteScroll.complete();
      return;
    }
    this.apiService
      .post(this.apiUrl, this.postParams, this.ordersApiResponse.next_page_url)
      .subscribe(data => {
        this.ordersApiResponse = data["data"];
        this.ordersData = this.ordersData.concat(data["data"]["data"]);
        infiniteScroll.complete();
      });
  }

  showCustomerModel(order_id) {
    let modalObject = this.modalController.create(CustomerModalPage, {
      order_id: order_id
    });

    modalObject.present();
  }

  showOrderDetailsModal(order_id) {
    this.getOrderDetails(order_id).then(data => {
      let modalObject = this.modalController.create(OrderdetailsModalPage, {
        orderDetails: data
      });

      modalObject.present();
    });
  }

  getOrderDetails(order_id) {
    return new Promise((resolve, reject) => {
      const params = {
        order_id
      };
      this.apiService
        .post("orders/get-order-details", params)
        .subscribe(result => {
          resolve(result);
        });
    });
  }

  doRefresh(refresher) {
    this.getOrders(refresher);
  }
}


// WEBPACK FOOTER //
// ./src/pages/orders/ordercancelled/ordercancelled.ts